function addIntToHex(hex, value) {
  // Transforma hex em inteiro
  let intValue = parseInt(hex, 16);
  intValue = intValue + value;
  // Transforma inteiro em hex
  return intValue.toString(16);
}

module.exports = addIntToHex;
